export class Translation {
  key: string = '';
  value: string = '';
} 
